<template>
  <Transition name="dialog">
    <div
      v-if="show"
      class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-6"
      @click.self="handleClose"
    >
      <div
        class="bg-white rounded-3xl p-6 max-w-sm w-full shadow-xl"
        @click.stop
      >
        <div class="text-center mb-4">
          <div class="text-3xl mb-2">✓</div>
          <h3 class="font-bold text-lg text-textMain">已標記為「已設定」</h3>
        </div>

        <div class="text-sm text-textMuted mb-6 text-center leading-relaxed">
          再次點擊可重新打開日曆或取消標記
        </div>

        <button
          @click="handleClose"
          class="w-full bg-primary text-white font-bold py-3 rounded-xl active:scale-[0.98] transition-transform"
        >
          我知道了
        </button>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  close: []
}>()

const handleClose = () => {
  emit('close')
}
</script>

<style scoped>
.dialog-enter-active,
.dialog-leave-active {
  transition: opacity 0.3s ease;
}

.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
}

.dialog-enter-active .bg-white,
.dialog-leave-active .bg-white {
  transition: transform 0.3s ease;
}

.dialog-enter-from .bg-white,
.dialog-leave-to .bg-white {
  transform: scale(0.95);
}
</style>
